import { isElementInViewport } from '../lib/viewport';

function handleOpen(detail, selector) {
  const siblings = [...detail.parentNode.querySelectorAll(selector)].filter(
    (sibling) => sibling !== detail,
  );

  const open = (detail) => {
    detail.open = true;
    detail.classList.remove('is-closing');
    setTimeout(() => {
      detail.classList.add('is-opening');
    }, 1);
  };

  const close = (detail) => {
    detail.classList.remove('is-opening');
    detail.classList.add('is-closing');
    setTimeout(() => {
      detail.open = false;
    }, 500);
  };

  if (detail.open) {
    close(detail);
  } else {
    open(detail);

    siblings.forEach((sibling) => {
      if (sibling.open) close(sibling);
    });
  }

  const summary = detail.querySelector('summary');
  setTimeout(() => {
    if (!isElementInViewport(summary)) {
      summary.scrollTo();
    }
  }, 10);
}

export function initDetailsGroup(selector = '.details-group details') {
  const details = document.querySelectorAll(selector);
  details.forEach((detail) => {
    if (detail.open) detail.classList.add('is-opening');

    detail.querySelector('summary').addEventListener('click', (e) => {
      e.preventDefault();
      handleOpen(detail, selector);
    });
  });
}
